import React from "react" 
import { useState, useEffect } from "react"
import { Link, useNavigate } from "react-router-dom"
import { toast } from "react-toastify"

import {
  Card,
  Col,
  Container,
  Row,
  CardBody,
  CardTitle,
  Label,
  Button,
  Form,
  Input,
  CardSubtitle,
  Table,
  InputGroup,
} from "reactstrap"
import { addRefferedby } from "service/api"

const defaultValue = {
  name: "",
  color: ""
}

const Addrefferedby = () => {
  const [refferedby, setReff] = useState(defaultValue);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

   useEffect(() => {
            document.title = "Reffered By | Add Reffered By";
          }, []);
  

  const onValueChange = (e) => {
    const { name, value } = e.target;
    setReff({ ...refferedby, [name]: value });

    // Clear field-specific validation error
    if (errors[name]) {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    }
  };

  const validate = () => {
    let formErrors = {};
    if (!refferedby.name.trim()) {
      formErrors.name = "Referred By name is required";
    }
    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  const handleAddReff = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    setLoading(true);
    try {
      await addRefferedby(refferedby);
      toast.success("Referred By saved successfully.", {
        position: "top-center",
        autoClose: 1500,
      });
      navigate("/refferedby");
    } catch (error) {
      toast.error("Failed to save referred by.");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div className="d-flex justify-content-between align-items-center mb-2">
            <h4 className="page-title"> Add Reffered By </h4>
            <Link to="/refferedby" className="btn btn-danger">Reffered By</Link>
          </div>
          <Row>
            <Card>
              <CardBody>
                <Form>
                  <Row>
                    <Col md={3}>
                      <div className="mb-3">
                        <Label htmlFor="formrow-country-Input">Reffered By<span style={{ color: "red" }}>*</span></Label>
                        <Input
                          type="text"
                          className={`form-control ${errors.name ? "is-invalid" : ""}`}
                          name="name"
                          Placeholder="Enter Reffered By"
                          onChange={e => onValueChange(e)}
                        />
                         {errors.name && <div className="invalid-feedback">{errors.name}</div>}
                      </div>
                    </Col>
                    {/* <Col md={3}>
                      <div className="mb-3">
                        <Label htmlFor="formrow-country-Input">
                          Color
                        </Label>
                        <Input
                          type="color"
                          className="form-control"
                          name="color"
                          onChange={e => onValueChange(e)}
                        />
                      </div>
                    </Col> */}
                  </Row>
                  <div>
                     <Button
                      color="primary"
                      className="w-md mx-2"
                      onClick={handleAddReff}
                      disabled={loading}
                    >
                      {loading ? "Saving..." : "Save"}
                    </Button>
                  </div>
                </Form>
              </CardBody>
            </Card>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default  Addrefferedby ;
